module.exports = __webpack_public_path__ + "static/media/in-number-6.20c87c22.png";